import React from 'react';
import { ProductsLink } from './styles';

interface Props {
  label: string;
  to: string;
}
const BackToPageLink = ({ label, to }: Props) => (
  <ProductsLink
    linkText={label}
    linkColor="red"
    linkSize="small"
    route="internal"
    url={to}
  />
);

export default BackToPageLink;
